import { EMPTY_OBJECT } from '../../../shared/constants';
import { Appointment } from '../pages/steps/appointment';
import { AppointmentReserved } from '../pages/steps/appointment-reserved';
import { Confirmation } from '../pages/steps/confirmation';
import { ContactDetails } from '../pages/steps/details/contact-details';
import { Doctor } from '../pages/steps/details/doctor';
import { Emergency } from '../pages/steps/details/emergency';
import { HomeAddress } from '../pages/steps/details/home-address';
import { NameBirthdate } from '../pages/steps/details/name-birthdate';
import { NhiResidency } from '../pages/steps/details/nhi-residency';
import { History } from '../pages/steps/history';
import { Insurance } from '../pages/steps/insurance';
import { Medications } from '../pages/steps/medications';
import { Privacy } from '../pages/steps/privacy';
import { HealthQuestions } from '../pages/steps/questions';
import { Specialist } from '../pages/steps/specialist';
import { Start } from '../pages/steps/start';
import { healthQuestions } from './health-questions';
import { preferenceQuestions } from './preference-questions';

export const steps = [
  {
    path: 'start',
    component: Start,
    done: ({ acceptedInvite, acceptedPrivacy }) => acceptedInvite || acceptedPrivacy,
    props: {
      progress: 0.05,
    },
  },
  {
    path: 'privacy',
    component: Privacy,
    done: ({ acceptedPrivacy }) => acceptedPrivacy,
    props: {
      showMenu: false,
      progress: 0.1,
    },
  },
  {
    path: 'specialist',
    component: Specialist,
    done: ({ specialistId }) => !!specialistId,
    props: {
      progress: 0.15,
    },
  },
  {
    path: 'appointment',
    component: Appointment,
    done: (_, invite) => !!invite.appointment,
    props: {
      progress: 0.2,
    },
  },
  {
    path: 'appointment-reserved',
    component: AppointmentReserved,
    done: ({ contactConsent }) => typeof contactConsent === 'boolean',
    props: {
      progress: 0.25,
    },
  },
  {
    path: 'name-birthdate',
    namespace: 'page.details',
    nextLabel: 'page.details:name-birthdate.nextLabel',
    component: NameBirthdate,
    done: ({ patient }) =>
      !!patient?.namePrefix &&
      !!patient?.nameGiven &&
      !!patient?.nameFamily &&
      !!patient?.namePreferred &&
      !!patient?.dateOfBirth,
    props: {
      progress: 0.3,
    },
  },
  {
    path: 'nhi-residency',
    namespace: 'step.details',
    nextLabel: 'page.details:nhi-residency.nextLabel',
    component: NhiResidency,
    done: ({ patient }) => typeof patient?.isResident === 'boolean',
    props: {
      progress: 0.35,
    },
  },
  {
    path: 'home-address',
    namespace: 'step.details',
    nextLabel: 'page.details:home-address.nextLabel',
    component: HomeAddress,
    done: ({ patient }) => !!patient?.address,
    props: {
      progress: 0.4,
    },
  },
  {
    path: 'contact-details',
    namespace: 'step.details',
    nextLabel: 'page.details:contact-details.nextLabel',
    component: ContactDetails,
    done: ({ patient }) => !!patient?.email && !!patient?.mobileNumber,
    props: {
      progress: 0.425,
    },
  },
  {
    key: 'doctor',
    path: 'doctor',
    namespace: 'step.details',
    nextLabel: 'page.details:doctor.nextLabel',
    component: Doctor,
    done: ({ gp, medicalCentre }) => !!gp && !!medicalCentre,
    props: {
      progress: 0.5,
    },
  },
  {
    path: 'emergency',
    namespace: 'step.details',
    nextLabel: 'page.details:emergency.nextLabel',
    component: Emergency,
    done: ({ emergency }) =>
      !!emergency?.fullName && !!emergency?.relationship && !!emergency?.mobileNumber,
    props: {
      progress: 0.475,
    },
  },
  {
    path: 'insurance',
    component: Insurance,
    done: ({ insurance }) => !!insurance?.termsAccepted,
    props: {
      progress: 0.49,
    },
  },
  {
    path: 'health-questions',
    component: HealthQuestions,
    done: ({ healthQuestionsStarted }) => healthQuestionsStarted,
    props: {
      progress: 0.5,
    },
  },
  ...healthQuestions,
  {
    path: 'medications',
    component: Medications,
    done: ({ medicationsConfirmed }) => !!medicationsConfirmed,
    props: {
      progress: 0.6,
    },
  },
  {
    path: 'history',
    component: History,
    done: ({ proceduresManual }) => Array.isArray(proceduresManual),
    props: {
      progress: 0.6,
    },
  },
  ...preferenceQuestions,
  {
    path: 'confirmation',
    progress: 1,
    component: Confirmation,
    done: () => false,
  },
];

// This should always return a step!
export function getFirstNotDoneStep(progress = EMPTY_OBJECT, invite) {
  return steps.find((step) =>
    typeof step.done === 'function' ? !step.done(progress, invite) : false,
  );
}
